/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useIntl } from 'react-intl'
import { KTIcon } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useSelector } from 'react-redux'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem to='/devices' title='Dispositivi collegati' hasBullet={false} />

      <AsideMenuItem to='/barcode' title='Codice a barre di test' hasBullet={false} />

      <AsideMenuItem to='/order-status' title='le tue letture di cassa' hasBullet={false} />

      <AsideMenuItem to='/inventory' title='Gestisci il tuo inventario' hasBullet={false} />

      <AsideMenuItem to='/shopify-orders' title='Gestione ordini' hasBullet={false} />

      <AsideMenuItem to='/analytics' title='Analisi vendite' hasBullet={false} />

      <AsideMenuItem to='/notifications' title='Notifiche' hasBullet={false} />
      <AsideMenuItem to='/connessioni' title='Connessioni' hasBullet={false} />

    </>
  )
}
